export const enum ReportBizTypeEnum {
  PRIVACY = 1, // 隐私内容
  GENERAL = 2, // 普通咨询
  GUIDE_MENU = 3, // 导航菜单
  HOT_QUESTION = 4, // 热门问题
  FAQ = 5, // FAQ
  TAG = 6, // 标签
  TECH_AI = 7, // TECH-AI: 除feedback,点赞，点踩外
  AI_HOT_KEY = 8, // AI热词
  AI_CHAT = 9, // AI聊天: 点赞、点踩、feedback
  BANNER = 10, // 轮播图
  IM_JUMP = 11, // IM跳转
  SEARCH_KEY = 12, // 搜索关键词
  CATEGORY = 13, // 分类
  LOGISTICS_TICKET = 14, // 物流工单
}

export const enum ReportEventEnum {
  SHOW = 1, //曝光
  CLICK = 2, //点击
  UPVOTE = 3, //点赞
  NEGATIVE_VOTE = 4, //点踩
  IM_SUCCESS = 5, //IM跳转成功
  SUBMIT_PRE_SALE_TICKET = 6, //提交售前工单
  PRE_SALE_TICKET_SUCCESS = 7, //提交售前工单成功
  SUBMIT_TECH_TICKET = 8, //提交技术工单
  TECH_TICKET_SUCCESS = 9, //提交技术工单成功
  MATCH = 10, //匹配
  PRE_ADVICE = 11, //预建议,
  SUBMIT_DISLIKE_ADVICE = 12, //提交建议 - 点踩,
  WIKI_VIEW = 13, // WIKI查看,
  SUBMIT_LIKE_ADVICE = 14, // 提交建议 - 点赞,
}

export const enum ReportContentEnum {
  FAQ = 1, //FAQ
  EXTERNAL_LINK = 2, //外部链接
  TECH_AI = 3, //TECH-AI
  CATEGORY = 4, //分类
  TAG = 5, //标签
  HOT_QUESTION = 6, //热门问题
}
export const enum ReportKeywordContentEnum {
  SEARCH = 1, // 直接搜索, 直接聊天
  KEYWORD_ASSOCIATION = 2, // 关键词联想
  FAQ = 3, //FAQ
  AI_KEYWORD = 4, //AI关键词
  NAVIGATION_RECOMMENDATIONS = 5, //导航推荐
}
export const enum ReportParentContentEnum {
  DEFAULT = -1, // 默认
  CATEGORY = 1, // 分类
  TAG = 2, // 标签
  HOT_QUESTION = 3, // 热门问题
  GUIDE_MENU = 4, // 导航菜单
  AI_HOT_KEY = 5, // AI热词
  DIRECT_SEARCH = 6, // 直接搜索
  ASSOCIATION_SEARCH = 7, // 联想搜索
  ADVICE = 8, // 建议反馈
  FAQ = 9, // FAQ
}

// 公共参数
export const enum ReportSceneTypeEnum {
  NORMAL_CONSULT = 1,
  AI_CONSULT = 2,
}
export const enum ReportSourceTypeEnum {
  OFFICIAL_WEBSITE = 1,
  HANDY_APP = 2,
}
export const enum ReportDeviceTypeEnum {
  PC = "PC",
  MOBILE = "MOBILE",
}

export interface ReportQueuePropsType {
  bizType: ReportBizTypeEnum;
  content?: string;
  contentId?: string;
  contentType?: ReportContentEnum | ReportKeywordContentEnum;
  createTime: number;
  eventType: ReportEventEnum;
  extendField1?: number;
  extendField2?: string;
  extendField3?: number;
  extendField4?: string;
  parentContent?: string;
  parentContentId?: string;
  parentContentType?: ReportParentContentEnum;
  scene: ReportSceneTypeEnum;
  merge?: boolean;
  cacheKey?: string;
}

export interface ReportPropsTypes {
  bizType: ReportBizTypeEnum;
  client: ReportDeviceTypeEnum;
  content?: string;
  contentId?: string;
  contentType?: ReportContentEnum | ReportKeywordContentEnum;
  createTime: number;
  eventType: ReportEventEnum;
  extendField1?: number;
  extendField2?: string;
  extendField3?: number;
  extendField4?: string;
  languageCode: string;
  parentContent?: string;
  parentContentId?: string;
  parentContentType?: ReportParentContentEnum;
  region: string;
  scene: ReportSceneTypeEnum;
  source: ReportSourceTypeEnum;
  userId: string;
}
export interface RobotChatPropsType {
  behaviorCollect: ReportPropsTypes;
  content?: string;
  data: {
    userId: string;
    origin?: string;
    email?: string;
    orderNum?: string;
    attachment?: string;
    model?: string;
    address?: string;
    comment?: string;
    issueType?: string;
    issueTypeName?: string;
    testMachine?: string;
  };
  id?: string;
  idType?: number;
  language: string;
}
